<template>
    <div id="HVAC" class="w-100 tc black pb4">
        <div class="container w-100">
          
          <div class="relative dt w-100" :style="{ 'height': mobile ? '45vh': '80vh'}">
            <div class="w-100 b ph2 tc dtc white v-mid">
              <div class="f1">HVAC Supplies</div>
            </div>
          </div>
    
          <div class="dt w-90-ns center ">
            <div class="w-50-ns w-100 pt4-ns pt2 pic-container" :class="[mobile ? 'dib' : 'dtc v-mid']">
              <div class="pa3-ns">
                <!-- <img class="rockwool ph2" src="../assets/logos-color/126895559.png"/> -->
                <div class="mv3"><img class="w-40-ns w-60 ph2 quietflex" src="../assets/logos-color/thermafiber.png"/><div v-if="mobile"><br/></div></div>
                <img class="ph2 quietflex" src="../assets/logos-color/qf-black-logo.png"/><div v-if="mobile"><br/></div>

              </div>
              <div class=""><img class="w-50" src="https://thermaflex.net/wp-content/uploads/2016/03/flex-vent-km-flexible-duct.jpg"/></div>
              <!-- <div class="pa3-ns"><img class="sustainable" src="../assets/sustainable.png"/></div> -->
            </div>
    
            <div class="pt4" :class="[mobile ? 'w-90 dib tl' : 'w-50 lh-copy f4 dtc v-mid']">
                <h4>HVAC Supplies are essential components of heating, ventilation, and air conditioning systems in homes and commercial buildings. HVAC systems require regular maintenance to function efficiently, and HVAC supplies are crucial for that maintenance. These supplies include air filters, refrigerants, thermostats, ductwork, insulation, and more. Proper use of these supplies can help to extend the life of HVAC systems, lower energy costs, and improve indoor air quality, which is especially important for people with allergies or respiratory issues. Therefore, it is important to choose high-quality HVAC supplies and use them properly to ensure the longevity and efficiency of HVAC systems.</h4>
            </div>
          </div>

          <div class="resources pv5-ns pv3">
        <div class="f3 pb3">Specification Sheets</div>
        <div :class="[mobile ? '' : 'w-80 center tc']">

          <div :class="[mobile ? 'pv3  w-50 center' : 'ph3 dtc v-mid']">
            <a class="spec link ps-blue dtc v-mid" href="https://thermaflexsite.wpengine.com/wp-content/uploads/2017/05/KM_ProductSheet.pdf" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Flex-Vent KM Flexible Duct
              </div>
            </a>
          </div>

          <div :class="[mobile ? 'pv3  w-50 center' : 'ph3 dtc v-mid']">
            <a class="spec link ps-blue dtc v-mid" href="https://www.quietflex.com/s/QF-RipStop-Silver-Jacket_specsheet_2019.pdf" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Quietflex
              </div>
            </a>
          </div>


          
        </div>
      </div>
    
          <div class="w-20-ns tc w-70 mt4-ns mt2 center">
            <div class="f3-ns f4 pa1">
                <a class="link" :href="info.tel">
                  <div class="contact-button ps-blue b br3 bg-yellow tc pa2 link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
              </a> 
            </div>
          </div>
        </div>
    
      </div>
    </template>
    
    <script>
    export default {
      name: 'Denim',
      props: ['info', 'mobile'],
      data() {
        return {
          expand1: false,
          expand2: false,
          expand3: false,
        };
      },
      methods: {
      },
      components: { 
      }
    };
    </script>
    
    <style scoped>
    .moreless {
      -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
      filter: invert(100%);
    }
    .spec {
      border: black 1px solid;
      padding: .5rem;
      margin: 0.5rem .5rem;
      border-radius: 2%;
    }
    .spec:hover{
      background: rgb(15,55,111);
      color: white;
    }
    .spec:hover img {
        -webkit-filter: invert(1);
    }
    h3 {
      padding: 1rem;
      border: solid black 1px;
      background: rgb(15,55,111);
      text-align: center;
      color: white;
    }
    .relative {
      background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .5)), url("https://thermaflex.net/wp-content/uploads/2016/03/flex-vent-km-flexible-duct.jpg");
      background-repeat: no-repeat;
      background-size: cover; 
      background-position: 10% 50%;
    }
    .banner {
      background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7));
      max-height: 300px;
    }
    .absolute {
      top: 10%;
      right: 10%;
    }
    .rockwool {
      max-width: 350px;
    }
    .sustainable {
      max-height: 100px;
    }
    .contact-button {
      color: rgb(15,55,111) !important;
    }
    
    .contact-button:hover {
      background: rgb(15, 55, 111) !important;
      color: gold !important;
      box-shadow: gold 5px 5px !important;
      transition: .3s ease;
    }
    
    .contact-button {
      box-shadow: rgb(15,55,111) 5px 5px !important;
      background:gold 5px 5px !important;
      padding: .7rem !important;
      color: rgb(15, 55, 111) !important;
      transition: .3s ease;
    }
    .link {
      /* box-shadow: rgb(15,55,111) 3px 3px !important; */
      text-decoration: none;
    }
    
    
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    </style>